'use client';
import type { FunctionComponent } from 'react';

import type { Modal } from '@/ui-components/modal/types/modal-names';
import { CreateDocumentModal } from '../components/smart-cards/modals/create-document';
import { UploadDocumentModal } from '../components/smart-cards/modals/upload-document';
import { CustomersModal } from '../customer/modals/customers-modal';
import { ProjectDocumentModal } from '../document/modals/project-document-modal';
import { DocumentStatusModal } from '../document-status/modals/document-status-modal';
import { ProjectModal } from '../project/modals/project-modal';
import { ReleaseNotesModal } from '../release-notes/modals/release-notes-modal';
import { SharedDocumentsModal } from '../shared-document/modals/shared-documents-modal';
import { useNavigation } from '../utils/custom-hooks/use-navigation';
import { AlertModal } from './alert/alert';
import { CookieSettingsModal } from './cookie-settings/cookie-settings';
import { SupportModal } from './support/support';

const modals: { [key in Modal]: React.ReactElement } = {
  ProjectModal: <ProjectModal />,
  Alert: <AlertModal />,
  ProjectDocumentModal: <ProjectDocumentModal />,
  DocumentStatus: <DocumentStatusModal />,
  Support: <SupportModal />,
  CookieSettings: <CookieSettingsModal />,
  Customers: <CustomersModal />,
  ReleaseNotesModal: <ReleaseNotesModal />,
  SharedDocumentsModal: <SharedDocumentsModal />,
  CreateDocument: <CreateDocumentModal />,
  UploadDocument: <UploadDocumentModal />
};

export const Modals: FunctionComponent = () => {
  const { getSearchParams } = useNavigation();
  const { modal } = getSearchParams<{ modal: Modal }>();

  return modals[modal] || null;
};
